<div class="flex">
  <div class="logo gradient-button-container">
    <mat-icon [svgIcon]="(logo | async) || ''"></mat-icon>
  </div>
  <div>
    <h1 class="subtitle">{{(pgService.cachedPersonaGiuridica?.denominazione || (praticaProgressService.selectedPratica$
      | async)?.data?.denomination) ||
      ((praticaProgressService.selectedPratica$ | async)?.data?.piva)}}</h1>
  </div>
</div>
<h1>{{'Codice: ' + ((praticaProgressService.selectedPratica$ | async)?.data?.praticaCode || '')}}</h1>